import React, { useState, useContext, useEffect } from 'react';
import { Container, Row, Col, Spinner, Button, Tabs, Tab, Form, InputGroup, Modal } from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import { Renew } from './components/renew';
import { Trail } from './components/trails';
import { Pending } from './components/pending';
import { Disabled } from './components/disabled';
import { All } from './components/all';
import { AppContext } from '../App';
import { apiRequest } from '../utils/apiHelper';


export const HomePage = () => {
	const { user, setUser, link, accessToken, setAccessToken, getExpiredLoad, setGetExpiredLoad, getExpired, expired, setExpired,
		allAccounts, setAllAccounts, agents
	} = useContext(AppContext);
	const [detailModal, setDetailModal] = useState(false);
	const [getDetailsLoad, setGetDetailsLoad] = useState(false);
	const [details, setDetails] = useState();
	const getContactDetails = (id) => {
		setDetailModal(true);
		apiRequest({
			url: `${link}api/cs/view/account/details/`,
			method: 'POST',
			data: { account_id: id.substring(1) },
			token: accessToken,
			setLoading: setGetDetailsLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setDetails(data);
			}
		});
	}
	const [pending, setPending] = useState();
	const [trailAccounts, setTrailAccounts] = useState();
	const [disabledAccount, setDisabledAccount] = useState();

	const [tabName, setTabName] = useState('renew');
	const [summary, setSummary] = useState();
	const getSummary = () => {
		apiRequest({
			url: `${link}api/cs/view/summary/`,
			token: accessToken,
			setLoading: setGetExpiredLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setSummary(data);
			}
		});
	}
	const tabChange = (key) => {
		if (key === 'expiried') {
			setTabName('renew');
			getExpired();
			setSearchResult(prev => ({}));
		} else if (key === 'pending') {
			setTabName('pending');
			getPendingAccounts();
			setSearchResult(prev => ({}));
		} else if (key === 'trail') {
			setTabName('trail');
			getTrailAccounts();
			setSearchResult(prev => ({}));
		} else if (key === 'disabled') {
			setTabName('disabled');
			getDisabledAccounts();
			setSearchResult(prev => ({}));
		} else if (key === 'all') {
			setTabName('all');
			setSearchResult(prev => ({}));
			getAllAccounts();
		} else if (key === 'summary') {
			getSummary();
			setSearchResult(prev => ({}));
		}
	}
	const [addNewModal, setAddNewModal] = useState(false);
	useEffect(() => {
		if (!addNewModal) {
			setValidUser();
			setValidEmail();
		}
	}, [addNewModal]);
	const [reqUsername, setReqUsername] = useState(false);
	const [reqEmail, setReqEmail] = useState(false);
	const [reqPass, setReqPass] = useState(false);
	const [reqCpass, setReqCpass] = useState(false);
	const [validUser, setValidUser] = useState();
	const [usernameCheckLoad, setUsernameCheckLoad] = useState(false);
	const checkUsername = (username) => {
		if (username !== "") {
			apiRequest({
				url: `${link}api/cs/get/user/name/`,
				method: 'POST',
				data: { username: username },
				token: accessToken,
				setLoading: setUsernameCheckLoad,
				setAccessToken: setAccessToken,
				onSuccess: (data) => {
					setValidUser(data);
				}
			});
		} else {
			setValidUser();
		}
	}
	const [validEmail, setValidEmail] = useState();
	const [emailCheckLoad, setEmailCheckLoad] = useState(false);
	const checkEmail = (email) => {
		if (email !== "") {
			apiRequest({
				url: `${link}api/cs/get/email/id/`,
				method: 'POST',
				data: { email: email },
				token: accessToken,
				setLoading: setEmailCheckLoad,
				setAccessToken: setAccessToken,
				onSuccess: (data) => {
					setValidEmail(data);
				}
			});
		} else {
			setValidEmail();
		}
	}
	const [passMatchErr, setPassMatchErr] = useState(false);
	const [addAccountLoad, setAddAccountLoad] = useState(false);
	const [serverError, setServerError] = useState(false);
	const addAccount = (e) => {
		e.preventDefault();
		let username = e.target.username.value;
		let email = e.target.email.value;
		let pass = e.target.password.value;
		let cpass = e.target.password2.value;
		let contact = e.target.contact.value;
		let agent = e.target.agent.value;
		let user_count = e.target.staffs.value;
		if (username === "") {
			setReqUsername(true);
			setTimeout(() => { setReqUsername(false) }, 5000);
		}
		if (email === "") {
			setReqEmail(true);
			setTimeout(() => { setReqEmail(false) }, 5000);
		}
		if (pass === "") {
			setReqPass(true);
			setTimeout(() => { setReqPass(false) }, 5000);
		}
		if (cpass === "") {
			setReqCpass(true);
			setTimeout(() => { setReqCpass(false) }, 5000);
		}
		if (pass !== "" && cpass !== "") {
			if (pass !== cpass) {
				setPassMatchErr(true);
				setTimeout(() => { setPassMatchErr(false) }, 5000);
			}
		}
		if (username !== "" && email !== "" && pass !== "" && cpass !== "" && user_count !== "" && agent !== "" && pass === cpass) {
			if (validUser !== undefined && !validUser && validEmail !== undefined && !validEmail) {
				apiRequest({
					url: `${link}api/cs/add/account/`,
					method: 'POST',
					data: {
						username: username,
						email: email,
						password: pass,
						contact_details: contact,
						return_page: tabName,
						user_count: user_count,
						agent: agent.substring(1),
					},
					token: accessToken,
					setLoading: setAddAccountLoad,
					setAccessToken: setAccessToken,
					onSuccess: (data) => {
						setAddNewModal(false);
						if (!data.error) {
							if (tabName === 'renew') {
								setExpired(data.values);
								setUser(prev => ({ ...prev, counts: data.counts }));
							} else if (tabName === 'pending') {
								setPending(data.values);
								setUser(prev => ({ ...prev, counts: data.counts }));
							} else if (tabName === 'disabled') {
								setDisabledAccount(data.values);
								setUser(prev => ({ ...prev, counts: data.counts }));
							} else if (tabName === 'trail') {
								setTrailAccounts(data.values);
								setUser(prev => ({ ...prev, counts: data.counts }));
							} else if (tabName === 'all') {
								setAllAccounts(data.values);
								setUser(prev => ({ ...prev, counts: data.counts }));
							}
						} else {
							setServerError(true);
							setTimeout(() => { setServerError(false) }, 5000);
						}
					},
					onError: (err) => {
						setServerError(true);
						setTimeout(() => { setServerError(false) }, 5000);
					}
				});
			}
		}
	}

	const getTrailAccounts = () => {
		apiRequest({
			url: `${link}api/cs/get/trail/accounts/`,
			token: accessToken,
			setLoading: setGetExpiredLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setTrailAccounts(data.values);
				setUser(prev => ({ ...prev, counts: data.counts }));
			}
		});
	}
	const getPendingAccounts = () => {
		apiRequest({
			url: `${link}api/cs/get/pending/payment/accounts/`,
			token: accessToken,
			setLoading: setGetExpiredLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setPending(data.values);
				setUser(prev => ({ ...prev, counts: data.counts }));
			}
		});
	}
	const getDisabledAccounts = () => {
		apiRequest({
			url: `${link}api/cs/get/disabled/accounts/`,
			token: accessToken,
			setLoading: setGetExpiredLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setDisabledAccount(data.values);
				setUser(prev => ({ ...prev, counts: data.counts }));
			}
		});
	}
	const getAllAccounts = () => {
		apiRequest({
			url: `${link}api/cs/get/all/accounts/`,
			token: accessToken,
			setLoading: setGetExpiredLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setAllAccounts(data.values);
				setUser(prev => ({ ...prev, counts: data.counts }));
			}
		});
	}
	function errorAlert() {
		$.alert({
			title: 'Encountered an error!',
			content: 'Something went wrong',
			type: 'red',
			typeAnimated: true,
			buttons: {
				close: function () {
				}
			}
		});
	}
	const [disableId, setDisableId] = useState();
	const [disableLoad, setDisableLoad] = useState(false);
	const disableAccount = (did, username) => {
		setDisableId(did);
		$.confirm({
			title: 'Do you want to disable account ?',
			content: 'Account username : ' + username,
			type: 'blue',
			typeAnimated: true,
			buttons: {
				ok: {
					text: 'Disable',
					btnClass: 'btn-blue',
					action: function () {
						apiRequest({
							url: `${link}api/cs/disable/account/`,
							method: 'POST',
							data: {
								return_page: tabName,
								account_id: did.substring(1),
							},
							token: accessToken,
							setLoading: setDisableLoad,
							setAccessToken: setAccessToken,
							onSuccess: (data) => {
								if (!data.error) {
									if (tabName === 'renew') {
										setExpired(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'pending') {
										setPending(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'disabled') {
										setDisabledAccount(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'trail') {
										setTrailAccounts(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'all') {
										setAllAccounts(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									}
								} else {
									errorAlert();
								}
							},
							onError: () => {
								errorAlert();
							}
						});
					}
				},
				cancel: function () { }
			}
		});
	}
	const [enableId, setEnableId] = useState();
	const [enableLoad, setEnableLoad] = useState(false);
	const enableAccount = (did, username) => {
		setEnableId(did);
		$.confirm({
			title: 'Do you want to enable account ?',
			content: 'Account username : ' + username,
			type: 'blue',
			typeAnimated: true,
			buttons: {
				ok: {
					text: 'Enable',
					btnClass: 'btn-blue',
					action: function () {
						apiRequest({
							url: `${link}api/cs/enable/account/`,
							method: 'POST',
							data: {
								return_page: tabName,
								account_id: did.substring(1),
							},
							token: accessToken,
							setLoading: setEnableLoad,
							setAccessToken: setAccessToken,
							onSuccess: (data) => {
								setEnableId();
								if (!data.error) {
									if (tabName === 'renew') {
										setExpired(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'pending') {
										setPending(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'disabled') {
										setDisabledAccount(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'trail') {
										setTrailAccounts(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'all') {
										setAllAccounts(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									}
								} else {
									errorAlert();
								}
							},
							onError: () => {
								setEnableId();
								errorAlert();
							}
						});
					}
				},
				cancel: function () { }
			}
		});
	}
	const [payId, setPayId] = useState();
	const [payReciveLoad, setPayReciveLoad] = useState(false);
	const payRecived = (pid, username) => {
		setPayId(pid);
		$.confirm({
			title: 'Confirm payment received ?',
			content: 'Account username : ' + username,
			type: 'blue',
			typeAnimated: true,
			buttons: {
				ok: {
					text: 'Confirm',
					btnClass: 'btn-blue',
					action: function () {
						apiRequest({
							url: `${link}api/cs/collect/account/payment/`,
							method: 'POST',
							data: {
								return_page: tabName,
								renew_id: pid,
							},
							token: accessToken,
							setLoading: setPayReciveLoad,
							setAccessToken: setAccessToken,
							onSuccess: (data) => {
								setPayId();
								if (!data.error) {
									if (tabName === 'renew') {
										setExpired(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'pending') {
										setPending(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'disabled') {
										setDisabledAccount(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'trail') {
										setTrailAccounts(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									} else if (tabName === 'all') {
										setAllAccounts(data.values);
										setUser(prev => ({ ...prev, counts: data.counts }));
									}
								} else {
									errorAlert();
								}
							},
							onError: () => {
								setPayId();
								errorAlert();
							}
						});
					}
				},
				cancel: function () { }
			}
		});
	}
	const [searchResult, setSearchResult] = useState({});
	const searchMap = (keyword, arr) => {
		setSearchResult(prev => ({}));
		if (arr !== undefined) {
			if (Object.keys(arr).length > 0) {
				Object.keys(arr).map((item, index) => {
					if (arr[item].account_name.toLowerCase().includes(keyword.toLowerCase())) {
						setSearchResult(prev => ({ ...prev, [item]: arr[item] }));
					}
				});
			}
		}
	}
	const search = (keyword) => {
		if (keyword !== "" && tabName !== undefined) {
			if (tabName === 'renew') {
				searchMap(keyword, expired);
			} else if (tabName === 'pending') {
				searchMap(keyword, pending);
			} else if (tabName === 'trail') {
				searchMap(keyword, trailAccounts);
			} else if (tabName === 'disabled') {
				searchMap(keyword, disabledAccount);
			} else if (tabName === 'all') {
				searchMap(keyword, allAccounts);
			}
		} else {
			setSearchResult(prev => ({}));
		}
	}
	useEffect(() => {
		let x = $('#search_box').val();
		if (x !== "") {
			search(x);
		}
	}, [expired, trailAccounts, pending, disabledAccount, allAccounts]);

	return (
		<Container className="py-3">

			<Col xs={12} sm={12} md={12} lg={12} className='bdr2 br-3 mb-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
					<span>{getExpiredLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Accounts.'}</span>
					<Button onClick={() => { setAddNewModal(true) }} className="btn-t1" ><i className="bi bi-plus-circle"></i> Add new</Button>

				</Col>
			</Col>
			<Col xs={12} sm={12} md={12} lg={12} className="service-search mb-1" >
				<Form>
					<InputGroup>
						<Form.Control onChange={(e) => { search(e.target.value) }} id="search_box" className="br-2" size="lg" type="text" placeholder="Search by username" />
						<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
					</InputGroup>
				</Form>
			</Col>
			<Tabs defaultActiveKey="expiried" className="mt-2" onSelect={(e) => { tabChange(e) }} >
				<Tab eventKey="expiried" title={`Upcoming Renewables ( ${user.counts.expired} )`} className="tab-body" >
					<Renew details={getContactDetails} did={disableId} disLoad={disableLoad} disAcc={disableAccount}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
				</Tab>
				<Tab eventKey="trail" title={`Trail Accounts ( ${user.counts.trails} )`} className="tab-body" >
					<Trail accounts={trailAccounts} details={getContactDetails} did={disableId} disLoad={disableLoad} disAcc={disableAccount}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
				</Tab>
				<Tab eventKey="pending" title={`Pending Payments ( ${user.counts.pending} )`} className="tab-body" >
					<Pending accounts={pending} details={getContactDetails} did={disableId} disLoad={disableLoad}
						disAcc={disableAccount} payid={payId} paRecLoad={payReciveLoad} payRecive={payRecived}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
				</Tab>
				<Tab eventKey="disabled" title={`Disabled Accounts ( ${user.counts.disabled} ) `} className="tab-body" >
					<Disabled accounts={disabledAccount} details={getContactDetails} did={disableId} disLoad={disableLoad} disAcc={disableAccount}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} search={searchResult} />
				</Tab>
				<Tab eventKey="all" title={`All ( ${user.counts.all} ) `} className="tab-body" >
					<All accounts={allAccounts} details={getContactDetails} did={disableId} disLoad={disableLoad}
						disAcc={disableAccount} search={searchResult}
						enable={enableAccount} enableId={enableId} enableLoad={enableLoad} />
				</Tab>
				{
					user !== undefined ? (
						user.type === 'admin' ? (
							<Tab eventKey="summary" title={`Summary`} className="tab-body" >
								{
									summary !== undefined ? (
										<Row className="mx-0">
											<div className="detail-grid px-3 py-2  tp2">
												<span>Amount to be remitted</span>
												<span>{summary.pending_amount}</span>
											</div>
											<div className="detail-grid px-3 pb-2 tp2">
												<span>Remaining remittance accounts</span>
												<div>
													<span className="d-grid">{summary.pending_count}</span>
													<div className="renewed-users">
														{
															summary.values !== undefined ? (
																Object.keys(summary.values).length > 0 ? (
																	Object.keys(summary.values).map((item, i) => (
																		<div className="remit-item bdr1 br-3 bgs1 m-1 p-2" key={`remi_${i}`} >
																			<span className="detail-grid f18" >{summary.values[item].account_name}</span>
																			<span className="f12" >Expiry : {summary.values[item].expiry_date}</span>
																		</div>
																	))
																) : 'Nothing found in remittance'
															) : 'Fetching data...'
														}
													</div>
												</div>
											</div>
										</Row>
									) : ''
								}
							</Tab>
						) : ''
					) : ''
				}
			</Tabs>
			<Modal size="lg" show={detailModal} backdrop="static" onHide={() => { setDetailModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Account details</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{
						getDetailsLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (
							details !== undefined ? (
								<Row>
									<div className="detail-grid mb-3 bdrb2">
										<span>Center name</span>
										<span>{details.center_name}</span>
									</div>
									<div className="detail-grid mb-3 bdrb2">
										<span>Username</span>
										<span>{details.username}</span>
									</div>
									<div className="detail-grid mb-3 bdrb2">
										<span>Expiry date</span>
										<span>{details.license_expiry_date}</span>
									</div>
									<div className="detail-grid mb-3 bdrb2">
										<span>Contact details</span>
										<p className="p-multi-line m-0" >{details.contact_details}</p>
									</div>
									<div className="detail-grid mb-3 bdrb2">
										<span>Phone number</span>
										<span>{details.phone_numbers}</span>
									</div>
									<div className="detail-grid mb-3 bdrb2">
										<span>Address</span>
										<p className="p-multi-line m-0" >{details.address}</p>
									</div>
								</Row>
							) : (<span className="tp3 p-3" >Nothing found!.</span>)
						)
					}
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
			<Modal size="lg" show={addNewModal} backdrop="static" onHide={() => { setAddNewModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>
						{
							serverError !== undefined && serverError ? (
								<span className='error-text' >Something went wrong!</span>
							) : 'Add new account'
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addAccount} >
						<Row>
							<Col xs={12} sm={12} md={6}>
								<Form.Group className="mb-3" >
									<Form.Label className="tp2" >Username
										{
											usernameCheckLoad ? (
												<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
											) : (
												validUser !== undefined ? (
													validUser ? (
														<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Already taken</span>
													) : (
														<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
													)
												) : ''
											)
										}
										{reqUsername ? (<span className="error-message" >This field is required</span>) : ''}
									</Form.Label>
									<Form.Control onBlur={(e) => { checkUsername(e.target.value) }} type="text" name="username" className="shadow-none br-2" placeholder="Username" />
								</Form.Group>
							</Col>
							<Col xs={12} sm={12} md={6}>
								<Form.Group className="mb-3" >
									<Form.Label className="tp2">Email
										{
											emailCheckLoad ? (
												<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
											) : (
												validEmail !== undefined ? (
													validEmail ? (
														<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Already taken</span>
													) : (
														<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
													)
												) : ''
											)
										}
										{reqEmail ? (<span className="error-message" >This field is required</span>) : ''}
									</Form.Label>
									<Form.Control onBlur={(e) => { checkEmail(e.target.value) }} type="email" name="email" className="shadow-none br-2" placeholder="Email id" />
								</Form.Group>
							</Col>
						</Row>
						<Row>
							<Col xs={12} sm={12} md={6}>
								<Form.Group className="mb-3" >
									<Form.Label className="tp2">Agent</Form.Label>
									<Form.Select name="agent" className="shadow-none br-2" >
										<option value="">Select agent</option>
										{
											agents !== undefined && Object.keys(agents).length > 0 ? (
												Object.keys(agents).map((item, i) => (
													<option key={i} value={item}>{agents[item].name}</option>
												))
											) : ''
										}
									</Form.Select>
								</Form.Group>
							</Col>
							<Col xs={12} sm={12} md={6}>
								<Form.Group className="mb-3" >
									<Form.Label className="tp2">Number of Staffs</Form.Label>
									<Form.Control type="number" name="staffs" className="shadow-none br-2" placeholder="Number of Staffs" />
								</Form.Group>
							</Col>
						</Row>
						<Row>
							<Col xs={12} sm={12} md={6}>
								<Form.Group className="mb-3" >
									<Form.Label className="tp2">Password
										{reqPass ? (<span className="error-message" >This field is required</span>) : ''}
										{passMatchErr ? (<span className="error-message" >Password and Confirm password do not match!</span>) : ''}
									</Form.Label>
									<Form.Control type="password" name="password" className="shadow-none br-2" placeholder="Password" />
								</Form.Group>
							</Col>
							<Col xs={12} sm={12} md={6}>
								<Form.Group className="mb-3" >
									<Form.Label className="tp2">Confirm Password {reqCpass ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
									<Form.Control type="password" name="password2" className="shadow-none br-2" placeholder="Confirm password" />
								</Form.Group>
							</Col>
						</Row>
						<Form.Group className="mb-3" >
							<Form.Label className="tp2">Contact details</Form.Label>
							<Form.Control as="textarea" name="contact" className="shadow-none br-2" />
						</Form.Group>
						<div className="d-grid">
							{
								addAccountLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1">SUBMIT</Button>
								)
							}
						</div>
					</Form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		</Container>
	)
}
